import { render, staticRenderFns } from "./CopyAdvertisement.vue?vue&type=template&id=ce4b25e0&"
import script from "./CopyAdvertisement.vue?vue&type=script&lang=js&"
export * from "./CopyAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports